<template>
  <div class="table-wrapper">
    <div class="table-fixed">
      <table>
        <TableHeader
          :excludeList="excludeList"
          :headerList="headerList"
        />
        <TableBody
          :bodyList="data"
          :excludeList="excludeList"
          :headerList="headerList"
          :identifier="identifier"
        />
      </table>
    </div>
    <hr>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import TableHeader from '@/components/generic/bulk/table_header.vue';
import TableBody from '@/components/generic/bulk/table_body.vue';

const props = defineProps({
  /** Data for the table */
  data: { type: Array, required: true, default: () => [] },
  /**
   * Current loading state of the incoming data,
   * Expects `plant`, `ship`, `shaft` or `equipment`.
   */
  identifier: {
    type: String,
    required: true,
    default: 'plant',
    validator(value) {
      return ['plant', 'ship', 'shaft', 'equipment'].includes(value);
    }
  },
});

const excludeList = [
  'id',
  'edit',
  'images', // TODO: remove when we add images
  'location',
  'priority',
  'new_rating',
  'requires_task',
  'det_mech_panel',
  'tasks_attributes',
  'tasks_close_issue',
  'location_description',
  'overall_condition_rating',
];

const headerList = computed(() => Object.keys(props.data[0]));
</script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.table-wrapper {
  max-height: fit-content;
  padding: bu(1);

  button {
    margin-top: bu(1);
  }
}

.table-fixed {
  overflow-y: scroll;
  overflow-x: scroll;
  height: fit-content;
  max-height: 93vh;

  table {
    border-collapse: collapse;
    min-width: max-content;
    width: 100%;
  }
}
</style>
